import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export function Carousel() {
    // redo sheet light and messages dark
    const images = [
        {
            light: "/images/Tabbed-Light-Messages.png",
            dark:  "/images/Tabbed-Dark-Messages.png",
            alt: "Messages view",
        },
        {
            light: "/images/Tabbed-Light-Doc.png",
            dark:  "/images/Tabbed-Dark-Doc.png",
            alt: "Doc view",
        },
        {
            light: "/images/Tabbed-Light-Whiteboard.png",
            dark:  "/images/Tabbed-Dark-Whiteboard.png",
            alt: "Whiteboard view",
        },
        {
            light: "/images/Tabbed-Light-Sheet.png",
            dark:  "/images/Tabbed-Dark-Sheet.png",
            alt: "Sheets view",
        },
        {
            light: "/images/Tabbed-Light-Split.png",
            dark:  "/images/Tabbed-Dark-Split.png",
            alt: "Split view",
        },
        {
            light: "/images/Tabbed-Light-Split-Fullscreen.png",
            dark:  "/images/Tabbed-Dark-Split-Fullscreen.png",
            alt: "Split view",
        },
    ];

    const [current, setCurrent] = useState(0);

    const prevSlide = () => setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    const nextSlide = () => setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));

    const { theme } = useTheme();

    useEffect(() => {
        const all = images.flatMap(i => [i.light, i.dark]);
        all.forEach(src => { const img = new Image(); img.src = src; });
    }, []);

    return (
        <div className="relative w-full aspect-photo bg-black border border-border shadow overflow-hidden flex items-center justify-center">
            {/* Image */}
            <img
                src={theme === "dark" ? images[current].dark : images[current].light}
                alt={images[current].alt}
                loading="eager"
                decoding="async"
                className="object-cover w-full h-full transition-all duration-500"
            />

            <button
                onClick={prevSlide}
                className="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-black/40 text-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-black/80 transition"
                aria-label="Previous Image"
                type="button"
            >
                <svg width="20" height="20" fill="none" viewBox="0 0 20 20">
                    <path d="M13 16l-5-6 5-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>
            <button
                onClick={nextSlide}
                className="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-black/40 text-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-black/80 transition"
                aria-label="Next Image"
                type="button"
            >
                <svg width="20" height="20" fill="none" viewBox="0 0 20 20">
                    <path d="M7 4l5 6-5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>
            {/* Dots */}
            <div className="absolute bottom-2 left-1/2 -translate-x-1/2 z-10 flex gap-1">
                {images.map((_, idx) => (
                    <button
                        key={idx}
                        onClick={() => setCurrent(idx)}
                        className={`w-2.5 h-2.5 rounded-full border border-white bg-white transition-opacity ${idx === current ? "opacity-80" : "opacity-30"}`}
                        aria-label={`Show slide ${idx + 1}`}
                        type="button"
                    />
                ))}
            </div>
        </div>
    );
}